<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CONVERSATION_PRIORITY } from 'shared/constants/messages';

import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  priority: {
    type: String,
    default: '',
  },
  showEmpty: {
    type: Boolean,
    default: false,
  },
});
const { t } = useI18n();

const icons = {
  [CONVERSATION_PRIORITY.URGENT]: 'i-woot-priority-urgent',
  [CONVERSATION_PRIORITY.HIGH]: 'i-woot-priority-high',
  [CONVERSATION_PRIORITY.MEDIUM]: 'i-woot-priority-medium',
  [CONVERSATION_PRIORITY.LOW]: 'i-woot-priority-low',
};

const priorityLabels = {
  [CONVERSATION_PRIORITY.URGENT]: 'CONVERSATION.PRIORITY.OPTIONS.URGENT',
  [CONVERSATION_PRIORITY.HIGH]: 'CONVERSATION.PRIORITY.OPTIONS.HIGH',
  [CONVERSATION_PRIORITY.MEDIUM]: 'CONVERSATION.PRIORITY.OPTIONS.MEDIUM',
  [CONVERSATION_PRIORITY.LOW]: 'CONVERSATION.PRIORITY.OPTIONS.LOW',
};

const iconName = computed(() => {
  if (props.priority && icons[props.priority]) {
    return icons[props.priority];
  }
  return props.showEmpty ? 'i-woot-priority-empty' : '';
});

// BonBoZ: mỗi mức một màu. Trước đây cả bốn mức dùng chung `text-n-slate-5` —
// một thang 4 bậc vẽ bằng đúng một sắc xám nhạt đến mức gần như không thấy,
// nên đặt mức ưu tiên xong cũng chẳng ai nhìn ra.
//
// Chỉ HAI bậc trên được ăn màu. "Trung bình" và "thấp" giữ xám là CỐ Ý: màu
// dùng để kéo mắt về việc cần làm, tô cả bốn bậc thì không bậc nào nổi nữa.
const mauUuTien = {
  [CONVERSATION_PRIORITY.URGENT]: 'text-n-ruby-9',
  [CONVERSATION_PRIORITY.HIGH]: 'text-n-amber-10',
  [CONVERSATION_PRIORITY.MEDIUM]: 'text-n-slate-10',
  [CONVERSATION_PRIORITY.LOW]: 'text-n-slate-9',
};

const lopMau = computed(() => mauUuTien[props.priority] || 'text-n-slate-5');

const tooltipContent = computed(() => {
  if (props.priority && priorityLabels[props.priority]) {
    return t(priorityLabels[props.priority]);
  }

  if (props.showEmpty) {
    return t('CONVERSATION.PRIORITY.OPTIONS.NONE');
  }

  return '';
});
</script>

<template>
  <Icon
    v-tooltip.top="{
      content: tooltipContent,
      delay: { show: 500, hide: 0 },
    }"
    :icon="iconName"
    class="size-4"
    :class="lopMau"
  />
</template>
